<template>
    <div>
        <el-input
                ref="main"
                :placeholder="$t(placeholder)"
                :value="showValue"
                :size="size"
                :clearable="disabled?false:clearable"
                :disabled="disabled"

                @clear="handleInputClear"
                @focus="handleShow">
            <span slot="append"
                    @click="handleShow">
                <el-button slot="append" icon="el-icon-user"></el-button>
            </span>
        </el-input>
        <l-dialog
            :title="$t(placeholder)"
            :visible.sync="dialogVisible"
            :height="480"
            width="1024px"
            :hasBtns="multiple"

            @ok="handleSelectMultiple"
            @opened="handleDialogOpened"
            >
            <l-layout class="l-tab-page" :left="240">
                <template #left  >
                    <l-panel :title="$t('所在单位')" style="padding-right:0;" >
                        <el-tree :data="companyTree" default-expand-all :expand-on-click-node="false"  @node-click="handleCompanyClick">
                            <span slot-scope="{ node}">
                                {{ $t(node.label) }}
                            </span>
                        </el-tree>
                    </l-panel>
                </template>
                <l-layout>
                    <template #left >
                        <l-panel :title="$t('所在部门')" style="padding-left:0;padding-right:0;" >
                            <el-tree :data="departmentsTree" default-expand-all :expand-on-click-node="false"  @node-click="handleDepartmentClick">
                                <span  slot-scope="{ node}">
                                    {{ $t(node.label) }}
                                </span>
                            </el-tree>
                        </l-panel>
                    </template>
                    <l-select-panel
                        v-model="value2"
                        ref="selectPanel"
                        valueKey="f_ArchiveId"
                        :model="multiple?'service':'client'"
                        :columns="columns"
                        :loadSelectTable="loadSelectTable"
                        :selectedData.sync="selectedData"
                        :multiple="multiple"

                        @rowClick="handleSelectPanel"

                        style="padding:8px;padding-left:0;"
                    >
                        <template v-slot:f_CompanyId="scope" >
                            {{formatCompany(scope.row.f_CompanyId)}}
                        </template>
                        <template v-slot:f_DepartmentId="scope" >
                            {{formatDepartment(scope.row.f_CompanyId,scope.row.f_DepartmentId)}}
                        </template>
                    </l-select-panel>
                </l-layout>
            </l-layout>
        </l-dialog>
    </div>
</template>

<script>

export default {
    name:'l-corr-archive-select',
    props: {
        value:{},
        size:{
            type:String,
            default:'mini'
        },
        placeholder:{
            type:String,
            default:'请选择'
        },

        disabled:{
            type:Boolean,
            default:false
        },
        clearable:{
            type:Boolean,
            default:true
        },
        multiple:{
            type:Boolean,
            default:false
        },
        sidx:{
            type:String,
            default:'F_CreateDate DESC'
        }
    },
    data () {
        return {
            dialogVisible:false,
            departmentList:[],
            text:'',
            companyId:'',
            departmentId:'',
            selectedData:[],
            departmentMaps:[],
            columns: [
                {label:'社矫机构',prop:'f_DepartmentId',minWidth:'88'},
                {label:'社矫对象',prop:'f_Name',minWidth:'110'},
                {label:'手机号码',prop:'f_PhoneNumber',width:'110'},
                {label:'人员编号',prop:'f_CorrNumber',minWidth:'120'},
            ],
            isInit:false,
            value2:''
        }
    },
    computed:{
        showValue(){
            if(this.lr_archiveName){
                return this.lr_archiveName(this.value)
            }
            else{
                return this.value
            }
        },
        companyTree(){
            if(this.lr_companyTree){
                return this.lr_companyTree
            }
            else{
                return []
            }
        },
        departmentsTree(){
            if(this.lr_departments){
                return this.lr_departmentTree(this.lr_departments[this.companyId])
            }
            else{
                return []
            }
        }
    },
    watch:{
        value:{
            handler(newVal){
                if(this.$validatenull(newVal)){
                    this.isInit = false
                }
                else{
                    this.lr_loadArchives && this.lr_loadArchives(newVal)
                }
            },
            immediate: true
        }
    },
    created(){
        this.lr_loadCompanys && this.lr_loadCompanys()
    },
    methods:{
        handleInputClear(){
            this.$refs.selectPanel && this.$refs.selectPanel.handleClear()
            this.value2 = ''
            this.$emit('input',this.value2)

            this.handleChange()
        },
        handleChange(val){
            this.$emit('change',val)
        },
        handleShow(){
            if(!this.disabled){
                this.dialogVisible = true
            }
        },
        tableLoadData(){
            this.$refs.selectPanel.init()
        },
        loadSelectTable(postData){
            return new Promise((resolve,reject) => {
                postData.sidx = this.sidx
                if(postData.showType == 1){
                    postData.f_CompanyId = this.companyId
                    postData.f_DepartmentId = this.departmentId
                }
                if(this.lr_getCorrArchivePage){
                    this.lr_getCorrArchivePage(postData).then(res=>{
                        const data = this.$deepClone(res)
                        resolve(data)
                    }).catch(err=>{
                        console.log(err)
                        reject(err)
                    })
                }else{
                    resolve({rows:[]})
                }
            })
        },

        formatCompany(value){
            if(this.lr_companyList){
                return (this.lr_companyList.find(t=>t.f_CompanyId == value) || {}).f_FullName || ''
            }
            else{
                return ''
            }
        },
        formatDepartment(companyId,id){
            if(this.lr_departmentName){
                return this.lr_departmentName(this.lr_departments[companyId] || [],id)
            }
            else{
                return id
            }
        },



        handleCompanyClick(node){
            this.lr_loadDepartments && this.lr_loadDepartments(node.f_CompanyId)
            this.companyId = node.f_CompanyId
            this.departmentId = ''
            this.tableLoadData()
        },
        handleDepartmentClick(node){
            this.departmentId = node.value
            this.tableLoadData()
        },
        handleDialogOpened(){
            if(this.value2 != this.value){
                this.value2 = this.value
                this.isInit = true
                this.tableLoadData()
            }
            if(!this.isInit){
                this.isInit = true
                this.tableLoadData()
            }
        },
        handleSelectPanel(row){
            this.text = row.f_Name
            this.$emit('input',this.value2)
            this.$refs.main.focus()
            this.$refs.main.blur()
            this.dialogVisible = false

            this.handleChange(row)
        },
        handleSelectMultiple(){
            this.$emit('input',this.value2)
            this.$refs.main.focus()
            this.$refs.main.blur()
            this.dialogVisible = false

            if(this.selectedData.length == 0){
                this.handleChange()
            }
            else{
                this.handleChange(this.selectedData)
            }

        }
    }
}
</script>
